var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "ModalMantenedor",
    { attrs: { show: _vm.show } },
    [
      _c(
        "CabeceraModal",
        { attrs: { titulo: _vm.titulo }, on: { cerrar: _vm.handleCerrar } },
        [
          !_vm.modoEditar
            ? _c("GuardarButton", { on: { click: _vm.handleGuardar } })
            : _vm._e(),
          _vm.modoEditar
            ? _c("GuardarCambiosButton", { on: { click: _vm.handleGuardar } })
            : _vm._e()
        ],
        1
      ),
      _c("ContenidoModal", [
        _c(
          "div",
          { attrs: { align: "center" } },
          [
            _c(
              "v-flex",
              { attrs: { md10: "" } },
              [
                _c(
                  "v-card",
                  { staticClass: "rounded-card" },
                  [
                    _c(
                      "v-container",
                      { attrs: { fluid: "", "grid-list-md": "" } },
                      [
                        _c(
                          "div",
                          { attrs: { align: "left" } },
                          [
                            _c("v-flex", { attrs: { md12: "" } }, [
                              _c(
                                "h2",
                                {
                                  staticClass: "h2_title",
                                  staticStyle: {
                                    "margin-top": "12px!important"
                                  }
                                },
                                [
                                  _vm._v(
                                    "\n                  Campo de Datos\n                "
                                  )
                                ]
                              )
                            ])
                          ],
                          1
                        ),
                        _c("v-divider"),
                        _c("br"),
                        _c(
                          "v-layout",
                          { attrs: { wrap: "" } },
                          [
                            _c(
                              "v-flex",
                              { attrs: { xs12: "", sm12: "", md12: "" } },
                              [
                                _c("v-text-field", {
                                  directives: [
                                    {
                                      name: "validate",
                                      rawName: "v-validate",
                                      value: "required|max:100",
                                      expression: "'required|max:100'"
                                    }
                                  ],
                                  attrs: {
                                    label: _vm.formFields.codigo.label,
                                    "error-messages": _vm.errors.collect(
                                      _vm.formFields.codigo.id
                                    ),
                                    "data-vv-name": _vm.formFields.codigo.id,
                                    counter: 100
                                  },
                                  model: {
                                    value: _vm.formFields.codigo.value,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.formFields.codigo,
                                        "value",
                                        $$v
                                      )
                                    },
                                    expression: "formFields.codigo.value"
                                  }
                                })
                              ],
                              1
                            ),
                            _c(
                              "v-flex",
                              { attrs: { xs12: "", sm6: "", md6: "" } },
                              [
                                _c("v-checkbox", {
                                  attrs: {
                                    label: _vm.formFields.requerido.label,
                                    "data-vv-name": _vm.formFields.requerido.id
                                  },
                                  model: {
                                    value: _vm.formFields.requerido.value,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.formFields.requerido,
                                        "value",
                                        $$v
                                      )
                                    },
                                    expression: "formFields.requerido.value"
                                  }
                                })
                              ],
                              1
                            ),
                            _c(
                              "v-flex",
                              { attrs: { xs12: "", sm6: "", md6: "" } },
                              [
                                _c("v-select", {
                                  directives: [
                                    {
                                      name: "validate",
                                      rawName: "v-validate",
                                      value: "required",
                                      expression: "'required'"
                                    }
                                  ],
                                  attrs: {
                                    label: _vm.formFields.tipo.label,
                                    "error-messages": _vm.errors.collect(
                                      _vm.formFields.tipo.id
                                    ),
                                    "data-vv-name": _vm.formFields.tipo.id,
                                    items: _vm.lstTipoDato,
                                    "item-text": "campo",
                                    "item-value": "id"
                                  },
                                  model: {
                                    value: _vm.formFields.tipo.value,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.formFields.tipo,
                                        "value",
                                        $$v
                                      )
                                    },
                                    expression: "formFields.tipo.value"
                                  }
                                })
                              ],
                              1
                            ),
                            _c(
                              "v-flex",
                              { attrs: { xs12: "", sm12: "", md12: "" } },
                              [
                                _c("v-text-field", {
                                  directives: [
                                    {
                                      name: "validate",
                                      rawName: "v-validate",
                                      value: "required|max:200",
                                      expression: "'required|max:200'"
                                    }
                                  ],
                                  attrs: {
                                    label: _vm.formFields.descripcion.label,
                                    "error-messages": _vm.errors.collect(
                                      _vm.formFields.descripcion.id
                                    ),
                                    "data-vv-name":
                                      _vm.formFields.descripcion.id,
                                    counter: 200
                                  },
                                  model: {
                                    value: _vm.formFields.descripcion.value,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.formFields.descripcion,
                                        "value",
                                        $$v
                                      )
                                    },
                                    expression: "formFields.descripcion.value"
                                  }
                                })
                              ],
                              1
                            ),
                            _c(
                              "v-flex",
                              { attrs: { xs12: "", sm12: "", md12: "" } },
                              [
                                _c("v-text-field", {
                                  directives: [
                                    {
                                      name: "validate",
                                      rawName: "v-validate",
                                      value: "required|max:100",
                                      expression: "'required|max:100'"
                                    }
                                  ],
                                  attrs: {
                                    label: _vm.formFields.regExp.label,
                                    "error-messages": _vm.errors.collect(
                                      _vm.formFields.regExp.id
                                    ),
                                    "data-vv-name": _vm.formFields.regExp.id,
                                    counter: 100
                                  },
                                  model: {
                                    value: _vm.formFields.regExp.value,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.formFields.regExp,
                                        "value",
                                        $$v
                                      )
                                    },
                                    expression: "formFields.regExp.value"
                                  }
                                })
                              ],
                              1
                            ),
                            _c(
                              "v-flex",
                              { attrs: { xs12: "", sm12: "", md12: "" } },
                              [
                                _c("v-text-field", {
                                  directives: [
                                    {
                                      name: "validate",
                                      rawName: "v-validate",
                                      value: "required|max:200",
                                      expression: "'required|max:200'"
                                    }
                                  ],
                                  attrs: {
                                    label: _vm.formFields.mensajeError.label,
                                    "error-messages": _vm.errors.collect(
                                      _vm.formFields.mensajeError.id
                                    ),
                                    "data-vv-name":
                                      _vm.formFields.mensajeError.id,
                                    counter: 200
                                  },
                                  model: {
                                    value: _vm.formFields.mensajeError.value,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.formFields.mensajeError,
                                        "value",
                                        $$v
                                      )
                                    },
                                    expression: "formFields.mensajeError.value"
                                  }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            )
          ],
          1
        )
      ]),
      _c("Confirmation", {
        attrs: {
          show: _vm.dialogConfirmacionGuardar,
          titulo: _vm.$t("mensajes.crud.crear.titulo", {
            entidad: "Campo de Datos"
          }),
          mensaje: _vm.$t("mensajes.crud.crear.mensaje", {
            entidad: "el Campo de Datos"
          }),
          textoBtnSi: _vm.$t("mensajes.crud.crear.btnAceptar"),
          textoBtnNo: _vm.$t("mensajes.crud.crear.btnCancelar")
        },
        on: {
          modalConfirmationEmit: function($event) {
            return _vm.confirmCallback($event)
          }
        }
      }),
      _c("Confirmation", {
        attrs: {
          show: _vm.dialogConfirmacionGuardarEditar,
          titulo: _vm.$t("mensajes.crud.editar.titulo", {
            entidad: "Campo de Datos",
            nombreEntidad: _vm.campoSeleccionado.codigoCampo
          }),
          mensaje: _vm.$t("mensajes.crud.editar.mensaje", {
            entidad: "el Campo de Datos"
          }),
          textoBtnSi: _vm.$t("mensajes.crud.editar.btnAceptar"),
          textoBtnNo: _vm.$t("mensajes.crud.editar.btnCancelar")
        },
        on: {
          modalConfirmationEmit: function($event) {
            return _vm.confirmCallback($event)
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }